module.exports = __webpack_public_path__ + "static/media/Manual_sencer_EN-4.ae756fb7.png";